import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fin-flight-filters-empty-state',
  templateUrl: './flight-filters-empty-state.component.html',
  styleUrls: ['./flight-filters-empty-state.component.scss'],
})
export class FlightFiltersEmptyStateComponent {
  @Output()
  clearAllFilters: EventEmitter<void> = new EventEmitter();
}
